<template lang="pug">
  #ClientSearch
    form(@submit.prevent="toSearch" @keyup.enter="toSearch")
      .input-group
        input(ref="search" id="product-search-query" class="form-control" type="search" v-model="q" minlength="2" :placeholder="placeholder.search" @keyup="changeSearch" @search="toSearch()")
        span.input-group-btn
          button.btn.btn-action(type="submit")
            img(:src="img.lupa" width="16" title="Search")
</template>
<script>
export default {
  name: 'OrderSearch',
  props: ['num'],
  data () {
    return {
      'q': null,
      'placeholder': {
        'search': this.$gettext('Buscar Oferta: Nombre de Cliente, N° de Oferta.')
      },
      'img': {
        'lupa': require('@/assets/img/icos/buscar.svg')
      }
    }
  },
  methods: {
    changeSearch () {
      let ref = this
      clearTimeout(this.timerSearch)
      this.timerSearch = setTimeout(() => {
        // console.log('---busca')
        ref.toSearch()
      }, 1000)
    },
    toSearch () {
      let query = this.q

      if (query !== null && query !== '' && query.length > 1) {
        // console.log(`to search: ${query},  ${query.length}`)
        this.$emit('toSearch', [query])
      }
    }
  }
}
</script>
<style lang="scss" scoped>
input[type="search"]{
  height:40px;
  line-height: 40px;
}
.btn{
  padding-top:0;
  padding-bottom:0;
  height:40px;
  line-height: 38px;
  img{
    max-width: none;
  }
}
</style>
